import { apiClient } from './api';

const BACKEND_GEOLOCATION_URL = '/geolocation/';

export const getUserLocation = async () => {
    try {
        const response = await apiClient.get(BACKEND_GEOLOCATION_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching user location:', error);
        return null;
    }
};